import React from "react";
import "./ReusableLoader.css";

const ReusableLoader: React.FC = () => {
  return (
    <div className="loader-backdrop">
      <div className="loader-spinner"></div>
    </div>
  );
};

export default ReusableLoader;
